import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api';
import MaestraLogo from '../components/MaestraLogo';
import RateLimitNotice from '../components/RateLimitNotice';
import PlatformFooter from '../components/PlatformFooter';

const ForgotPassword = () => {
  const navigate = useNavigate();
  document.title = 'Maestra - Reset Password';

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [rateLimitMessage, setRateLimitMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setRateLimitMessage('');
    setLoading(true);

    try {
      await authAPI.forgotPassword(email.trim().toLowerCase());
      setSubmitted(true);
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail || 'Something went wrong. Please try again.';
      if (status === 429) {
        setRateLimitMessage(detail);
      } else {
        setError(detail);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className="login-container">
          <div style={{ marginBottom: '32px' }}><MaestraLogo size="sm" /></div>

          {!submitted ? (
            <>
              <h1 className="login-title" data-testid="forgot-password-title">Reset access</h1>
              <p style={{
                fontFamily: 'Cormorant Garamond, Playfair Display, serif',
                fontStyle: 'italic',
                fontSize: '14px',
                color: 'var(--kahla-text-light)',
                textAlign: 'center',
                marginBottom: '24px',
                lineHeight: '1.7',
              }}>
                Enter the email connected to your workspace.<br />
                We'll send you a link to set a new password.
              </p>

              {error && <div className="login-error" data-testid="forgot-password-error">{error}</div>}
              <RateLimitNotice message={rateLimitMessage} testId="forgot-password-rate-limit-notice" />

              <form className="login-form" onSubmit={handleSubmit}>
                <div className="login-field">
                  <label htmlFor="forgot-password-email">Workspace email</label>
                  <input
                    id="forgot-password-email"
                    data-testid="forgot-password-email-input"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                  />
                </div>

                <button
                  data-testid="forgot-password-submit-btn"
                  type="submit"
                  className="btn-primary"
                  disabled={loading}
                  style={{ width: '100%', marginTop: '12px' }}
                >
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </form>
            </>
          ) : (
            <div data-testid="forgot-password-success" style={{ textAlign: 'center' }}>
              <h1 className="login-title">Check your inbox</h1>
              <p style={{
                fontSize: '13px',
                color: 'var(--kahla-text-light)',
                lineHeight: '1.7',
                letterSpacing: '0.02em',
                marginBottom: '8px',
              }}>
                If an account exists for <strong style={{ color: 'var(--kahla-text)' }}>{email}</strong>,
                you'll receive a password reset link shortly.
              </p>
              <p style={{
                fontSize: '12px',
                color: 'var(--kahla-text-light)',
                opacity: 0.7,
                marginTop: '16px',
              }}>
                Didn't receive anything? Check your spam folder.
              </p>
            </div>
          )}

          <div style={{ marginTop: '32px', textAlign: 'center' }}>
            <button
              data-testid="forgot-password-back-btn"
              className="btn-secondary"
              onClick={() => navigate('/login')}
              style={{ fontSize: '12px', padding: '10px 20px' }}
            >
              ← Back to Sign In
            </button>
          </div>
        </div>
      </div>

      <footer style={{
        width: '100vw',
        padding: '24px',
        textAlign: 'center',
        borderTop: '1px solid var(--kahla-border)',
        marginTop: 'auto',
      }}>
        <PlatformFooter variant="compact" />
      </footer>
    </div>
  );
};

export default ForgotPassword;
